import styled from "styled-components";

export const Error = styled.div`
  width: 100%;
  animation: slideDownAlert 0.4s;
`;
